import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import LayoutMain_Bus from "../LayoutMain_Bus/LayoutMain_Bus";
import { decodeToken } from "react-jwt";
import WaterMark from "../../Dashboard/DashboardMain/WaterMark";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";
import "./VehicleInsightBus.css";
import { GiArtificialIntelligence } from "react-icons/gi";
// import { createChatBotMessage } from "react-chatbot-kit";
import { getAsset } from "../../assets/assetLoader";

// import ChatBot from "react-chatbotify";

export default function VehicleInsights_Bus() {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  // const tokenNew = JSON.parse(sessionStorage.user);
  // let decodedToken = decodeToken(tokenNew.token);
  const [isDriveBusEnable, setIsDriveBusEnable] = useState(false);
  const [isRcaBusEnable, setIsRcaBusEnable] = useState(false);
  const [isFaultBusEnable, setIsFaultBusEnable] = useState(false);
  const [isChargingEnable, setIsChargingEnable] = useState(false);
  const [usernameTempHideShow, setUsernameTempHideShow] = useState(false);
  const [isCriticalVehicles, setCriticalVehicles] = useState(false);
  const [isCriticalVehiclesFleet, setCriticalVehiclesFleet] = useState(false);
  const [isTrendEnable, setIsTrendEnable] = useState(false);
  const [isEnergyAnalysis, setIsEnergyAnalysis] = useState(false);
  const [isEnergyBillReconcilliationFleet, setIsEnergyBillReconcilliationFleet] = useState(false);
  const [ispdfDownload, setIsPdfDownload] = useState(false);
  const [isChatBot, setIsChatBot] = useState(false);
  const [isBatteryDigitalTwin, setIsBatteryDigitalTwin] = useState(false);
  const [isLLM, setLLM] = useState(false);
  const [isPDL, setIsPDL]= useState(false)
  const [isTCU, setIsTCU]= useState(false)

  const loggedInUser = useSelector(selectLoggedInUser);

  const log_data = (data) => {
    //  console.log(data);
  };
  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "auth/logging",
        body: {
          page_name: "vehicleinsights_bus",
        },
      },
      log_data
    );

    // fetchData({
    //   url: API_URL_MAIN + "energy_analysis_bus/temp_bot", body: {
    //     "filterdata": "1"
    //   }
    // }, bot_re)
  }, []);

  // const bot_re = () => {
  //   console.log("hopeless");
  // }
  useEffect(() => {
    //let user_data = JSON.parse(sessionStorage.user);
    // console.log("called");
    // fetchData({
    //     url: API_URL_MAIN + "auth/logging", body: {
    //         page_name: "vehicleinsights"
    //     }
    // })
    const tokenNew = JSON.parse(sessionStorage.user);
    let decodedToken = decodeToken(tokenNew.token);
    const usernameNew = decodedToken.access_type;
    // const usernameNew = "1,2,3";
    // const usernameNew = "1";
    var split_str = usernameNew.split(",");
    
    if (split_str.indexOf("1") !== -1) {
      setIsDriveBusEnable(true);
    }
    if (split_str.indexOf("3") !== -1) {
      setIsRcaBusEnable(true);
    }
    if (split_str.indexOf("2") !== -1) {
      setIsFaultBusEnable(true);
    }
    if (split_str.indexOf("4") !== -1) {
      setIsChargingEnable(true);
    }
    if (split_str.indexOf("7") !== -1) {
      setIsTrendEnable(true);
    }
    if (split_str.indexOf("9") !== -1) {
      setUsernameTempHideShow(true);
    }
    if (split_str.indexOf("10") !== -1) {
      setCriticalVehicles(true);
    }
    if (split_str.indexOf("11") !== -1) {
      setCriticalVehiclesFleet(true);
    }
    if (split_str.indexOf("12") !== -1) {
      setIsEnergyAnalysis(true);
    }
    if (split_str.indexOf("13") !== -1) {
      setIsPdfDownload(true);
    }
    if (split_str.indexOf("16") !== -1) {
      setIsEnergyBillReconcilliationFleet(true);
    }
    if (split_str.indexOf("17") !== -1) {
      setIsBatteryDigitalTwin(true);
    }
    if (split_str.indexOf("18") !== -1) {
      setLLM(true);
    }
    if (split_str.indexOf("20") !== -1) {
      setIsPDL(true);
    }
    if (split_str.indexOf("21") !== -1) {
      setIsTCU(true);
    }
    // if (split_str.indexOf("15") !== -1) {
    //   setIsChatBot(true);
    // }
  }, [
    isDriveBusEnable,
    isRcaBusEnable,
    isFaultBusEnable,
    isChargingEnable,
    usernameTempHideShow,
    isCriticalVehicles,
    isTrendEnable,
    isEnergyAnalysis,
    isEnergyBillReconcilliationFleet,
    ispdfDownload,
    isBatteryDigitalTwin,
    // isChatBot,
  ]);

  const formatApiResponse = (data) => {
    // Ensure the data is a string
    if (typeof data !== "string") {
      data = String(data); // Convert non-string data to a string
    }

    // Split the data by lines
    let lines = data.split("\n");

    // Remove serial numbers from the lines
    lines = lines.map((line) => {
      if (typeof line === "string") {
        // Use a regular expression to remove the serial number at the start of the line
        return line.replace(/^\d+\s+/, "");
      }
      return line;
    });

    // Join the lines back together
    return lines.join("\n");
  };

  const llm_redirection = (e) => {
    const url = 'http://10.164.59.54:2000/'
    var win = window.open(url, "");
    win.focus();
  };

  // code for chatbot
  // async function fetchData_me(params) {
  //   console.log("params", params.userInput);
  //   try {
  //     const response = await fetch(API_URL_MAIN + "chat_bot/python_ai_bot", {
  //       method: "POST",
  //       // body: { "filterdata": params.userInput },
  //       // body: JSON.stringify({ filterdata: params.userInput }),
  //       body: JSON.stringify({ filterdata: params }),
  //       headers: {
  //         "Content-type": "application/json; charset=UTF-8",
  //         "x-auth-token":
  //           "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2Nlc3NfdHlwZSI6IjEsMiwzLDQsNiw3LDgsMTAsNywxMiw5LDExMSwxMSwxMyIsInVzZXJuYW1lIjoic205MjU0MTMudHRsIiwiaXBfYWRkcmVzcyI6IjE2My4xMTYuMjEzLjkyIiwibG9naW5fdGltZSI6IjYtMTctMjAyNCAxMjo0NDowMyIsInVzZXJfbG9nIjo0OTU1LCJ0YWJsZV9uYW1lIjoidG1sX2N2X2V2X2FnZ19ldl9idXNfZGlzY2hhcmdlX2N5Y2xlX2Rhc2hib2FyZCx0bWxfY3ZfZXZfYWdnX2V2X2J1c19mYXVsdF9hbGFybV9vY2NfZHVyX2FnZyx0bWxfY3ZfZXZfYWdnX2V2X2J1c19jaGFyZ2luZ19jeWNsZV9hZ2csdG1sX2N2X2V2X2FnZ19ldl9idXNfZmF1bHRfYWxhcm1fb2NjX2R1cl9hZ2csdG1sX2N2X2V2X2FnZ19ldl9idXNfaW1iYWxhbmNlX2R1cmF0aW9uX29jYyxzZWxmX3NlcnZpY2UsdHJlbmRfYW5hbHlzaXMsdGVtcF9uZXdfZGFzaGJvYXJkX2ZsYWcscGRmX2Rvd25sb2FkLHRtbF9jdl9ldl9hZ2dfZXZfYnVzX2NyaXRpY2FsX3ZlaGljbGUsdG1sX2N2X2V2X2FnZ19ldl9idXNfY3JpdGljYWxfdmVoaWNsZSx0bWxfY3ZfZXZfYWdnX2V2X2J1c19lbmVyZ3lfZGFzaGJvYXJkIiwiZXZfYnVzIjoiRVJDX0JVUyIsInVzZXJfdHlwZSI6IkVSQ19CVVMsRkxFRVRFVl9CVVMsRVJDX0FDRSxGTEVFVEVWX0FDRSIsImNpdHlfbmFtZSI6IiIsImRlcG9fbmFtZSI6IiIsImlhdCI6MTcxODYyODI0M30.ahflDDv8aBLZdMeQ61f5GM917yKL9sE1CmeRdfpHnoA",
  //       },
  //     });
  //     const data = await response.json();
  //     // console.log("ai data", data.message);
  //     // const messageString = data.message;
  //     // const dfString = messageString.match(/'df': '(.*?)'/)[1];
  //     // return data.title;
  //     // const formattedResult = formatApiResponse(data);
  //     // console.log(formattedResult);
  //     // return formattedResult;

  //     return data.message;
  //     // return dfString;
  //   } catch (error) {
  //     // return "Oh no I don't know what to say!";
  //     return error;
  //   }
  // }
  // let count = 0;

  // let inputData = {
  //   dashboard_type: "",
  //   question: "",
  // };

  // const flow = {
  //   start: {
  //     message:
  //       "Hi, I'm Fleet Ascents Saarthi ! \nI'm here to assist you with any questions about the Drive and Fault Dashboard. \nFeel free to start asking, and don't forget to mention the dashboard name in your question!",
  //     path: "loop",
  //   },
  //   loop: {
  //     message: async (params) => {
  //       let question = params.userInput;
  //       let input_lower = params.userInput.toLowerCase();
  //       if (input_lower.split(" ").includes("fault")) {
  //         Object.defineProperty(inputData, "dashboard_type", {
  //           value: "fault",
  //         });
  //         Object.defineProperty(inputData, "question", {
  //           value: question,
  //         });
  //         // inputData.dashboard_type = 'fault'
  //       } else if (input_lower.split(" ").includes("drive")) {
  //         Object.defineProperty(inputData, "dashboard_type", {
  //           value: "drive",
  //         });
  //         Object.defineProperty(inputData, "question", {
  //           value: question,
  //         });
  //       } else {
  //         Object.defineProperty(inputData, "dashboard_type", {
  //           value: "",
  //         });
  //         Object.defineProperty(inputData, "question", {
  //           value: input_lower,
  //         });
  //       }
  //       let result = "";
  //       if (question.split(" ").length < 35) {
  //         result = await fetchData_me(inputData);
  //       } else {
  //         result = "Please ask question which has less than 26 words.";
  //         // alert("Please ask question which has less than 26 words.");
  //       }

  //       return result;
  //     },
  //     path: "loop",
  //   },
  // };

  return (
    <LayoutMain_Bus>
      <div className="row bus_bg_c">
        <WaterMark />
        {
          // loggedInUser.flagForHideShow === "ERC" &&
          loggedInUser.flagForHideShow === "ERC" && isCriticalVehicles && (
            <div className="col-md-3">
              {/* <img src="../../../assets/work_in_progress_blue_final.png" style={{ width: "50px", height: "50px", position: "absolute", right: "25px", top: "30px" }}></img> */}
              <Link to="/dashboard_bus/criticalvehicles_bus">
                <div className="dashboard_card">
                  <img
                    src="../../../assets/img_Bus/Critical_Vehicles.png"
                    alt=""
                  />
                  <span>Critical Vehicles</span>
                </div>
              </Link>
            </div>
          )
        }
        {
          // loggedInUser.flagForHideShow === "ERC" &&
          loggedInUser.flagForHideShow === "FLEETEV" &&
          isCriticalVehiclesFleet && (
            <div className="col-md-3">
              {/* <img src="../../../assets/work_in_progress_blue_final.png" style={{ width: "50px", height: "50px", position: "absolute", right: "25px", top: "30px" }}></img> */}
              <Link to="/dashboard_bus/criticalvehicles_bus_fleet">
                <div className="dashboard_card">
                  <img
                    src="../../../assets/img_Bus/Critical_Vehicles.png"
                    alt=""
                  />
                  <span>Critical Vehicles</span>
                </div>
              </Link>
            </div>
          )
        }
        {isDriveBusEnable && (
          <div className="col-md-3">
            <Link to="/dashboard_bus/driveanalysis_bus">
              <div className="dashboard_card">
                <img
                  src="../../../assets/img_Bus/drive_analysis_bus.png"
                  alt=""
                />
                <span>Drive Analysis</span>
              </div>
            </Link>
          </div>
        )}
        {isFaultBusEnable && (
          <div className="col-md-3">
            {/* <Link to="/dashboard_bus/faultanalysis_bus"> */}
            <Link to="/dashboard_bus/faultanalysis_bus">
              <div className="dashboard_card">
                <img
                  src="../../../assets/img_Bus/fault_analysis_bus.png"
                  alt=""
                />
                <span>Fault Analysis</span>
              </div>
            </Link>
          </div>
        )}
        {
          // loggedInUser.flagForHideShow === "ERC" &&
          isRcaBusEnable && (
            <div className="col-md-3">
              <Link to="/dashboard_bus/rca_bus">
                <div className="dashboard_card">
                  <img
                    src="../../../assets/img_Bus/rca_vehicleInsights_card.png"
                    alt=""
                  />
                  <span>RCA</span>
                </div>
              </Link>
            </div>
          )
        }
        {/* sankalp */}
        {isChargingEnable && (
          <div className="col-md-3">
            <Link to="/dashboard_bus/charginganalysis_bus">
              <div className="dashboard_card">
                <img
                  src="../../../assets/img_Bus/CESL_Charging/charging_bus_main_card.png"
                  alt=""
                />
                <span>Charging Analysis</span>
              </div>
            </Link>
          </div>
        )}
        {
          // (loggedInUser.flagForHideShow === "ERC" && isEnergyAnalysis) &&
          isEnergyAnalysis && (
            <div className="col-md-3">
              <Link to="/dashboard_bus/energyanalysis_bus">
                <div className="dashboard_card">
                  <img
                    src="../../../assets/img_Bus/Energy_Analytics.png"
                    alt=""
                  />
                  <span>Energy Analytics</span>
                </div>
              </Link>
            </div>
          )
        }
        {loggedInUser.flagForHideShow === "ERC" && isBatteryDigitalTwin && (
          <div className="col-md-3">
            <Link to="/dashboard_bus/battery_digital_twin">
              <div className="dashboard_card">
                <img
                  src="../../../assets/img_Bus/Battery_Digital_Twins.png"
                  alt=""
                />
                <span>Battery Digital Twin</span>
              </div>
            </Link>
          </div>
        )}
        {isLLM && (
          <div className="col-md-3">
            {/* <Link to="http://10.164.59.54:2000/"> */}
            <div className="dashboard_card" onClick={llm_redirection}>
              {/* <img
                src="../../../assets/img_Bus/modified_image.png"
                alt=""
              /> */}
              <GiArtificialIntelligence style={{ color: "#83A4CF" }} size={50} />
              <span>LLM</span>
            </div>
            {/* </Link> */}
          </div>
        )}
        { isPDL && (
          <div className="col-md-3">
            <Link to="/dashboard_bus/PDL">
            <div className="dashboard_card" >
              {/* <img
                src="../../../assets/img_Bus/modified_image.png"
                alt=""
              /> */}
              <GiArtificialIntelligence style={{ color: "#83A4CF" }} size={50} />
              <span>PDL Device Health</span>
            </div>
            </Link>
          </div>
        )}
        { isTCU && (
          <div className="col-md-3">
            <Link to="/dashboard_bus/tcu">
            <div className="dashboard_card" >
              {/* <img
                src="../../../assets/img_Bus/modified_image.png"
                alt=""
              /> */}
              <GiArtificialIntelligence style={{ color: "#83A4CF" }} size={50} />
              <span>TCU Device Health</span>
            </div>
            </Link>
          </div>
        )}
        {
          // loggedInUser.flagForHideShow === "ERC" &&
          usernameTempHideShow && loggedInUser.flagForHideShow === "ERC" && (
            <>
              {/* <div className="col-md-3">
                <img
                  src="../../../assets/work_in_progress_blue_final.png"
                  alt=""
                  style={{
                    width: "50px",
                    height: "50px",
                    position: "absolute",
                    right: "25px",
                    top: "30px",
                  }}
                ></img>
                <Link to="/dashboard_bus/bdt">
                  <div className="dashboard_card">
                    <img
                      src="../../../assets/img_Bus/Battery_Digital_Twins.png"
                      alt=""
                    />
                    <span>Battery Digital Twin</span>
                  </div>
                </Link>
              </div> */}

              {/* <div className="col-md-3">
              <img src="../../../assets/work_in_progress_blue_final.png" style={{ width: "50px", height: "50px", position: "absolute", right: "25px", top: "30px" }}></img>
              <div className="dashboard_card">
                <img src="../../../assets/img_Bus/Energy_Analytics.png" />
                <span>Energy Analytics</span>
              </div>
            </div> */}
              <div className="col-md-3">
                <img
                  src={getAsset("work_in_progress_blue_final.png")}
                  alt=""
                  style={{
                    width: "50px",
                    height: "50px",
                    position: "absolute",
                    right: "25px",
                    top: "30px",
                  }}
                />
                {/* <Link to="/dashboard_bus/bdt"> */}
                <div className="dashboard_card">
                  <img
                    src="../../../assets/img_Bus/Motor_Analytics.png"
                    alt=""
                  />
                  <span>Motor Analytics</span>
                </div>
                {/* </Link> */}
              </div>
              <div className="col-md-3">
                <img
                  src={getAsset("work_in_progress_blue_final.png")}
                  alt=""
                  style={{
                    width: "50px",
                    height: "50px",
                    position: "absolute",
                    right: "25px",
                    top: "30px",
                  }}
                />
                {/* <Link to="/dashboard_bus/bdt"> */}
                <div className="dashboard_card">
                  <img
                    src="../../../assets/img_Bus/DC_DC_Converter_Analytics.png"
                    alt=""
                  />
                  <span>DCDC Converter Analytics</span>
                </div>
                {/* </Link> */}
              </div>
              <div className="col-md-3">
                <img
                  src={getAsset("work_in_progress_blue_final.png")}
                  alt=""
                  style={{
                    width: "50px",
                    height: "50px",
                    position: "absolute",
                    right: "25px",
                    top: "30px",
                  }}
                />
                {/* <Link to="/dashboard_bus/bdt"> */}
                <div className="dashboard_card">
                  <img
                    src="../../../assets/img_Bus/Aux_Inverter_Analytics.png"
                    alt=""
                  />
                  <span>AUX Inverter Analytics</span>
                </div>
                {/* </Link> */}
              </div>
            </>
          )
        }
        {
          // (isTrendEnable && loggedInUser.flagForHideShow === "FLEETEV") &&
          isTrendEnable && (
            <div className="col-md-3">
              <Link to="/dashboard_bus/trendanalysis_bus">
                <div className="dashboard_card">
                  <img
                    src="../../../assets/img_Bus/TrendAnalysis/trend3.png"
                    alt=""
                  />
                  <span>Trend Analysis</span>
                </div>
              </Link>
            </div>
          )
        }
        {loggedInUser.flagForHideShow === "ERC" && isEnergyAnalysis && (
          // ispdfDownload &&
          <div className="col-md-3">
            <Link to="/dashboard_bus/PdfFirstPage">
              <div className="dashboard_card">
                <img
                  src="../../../assets/img_Bus/monthlyReport.png"
                  alt=""
                />
                <span>Performance Report</span>
              </div>
            </Link>
          </div>
        )}

        {/* {loggedInUser.flagForHideShow === "FLEETEV" && isEnergyBillReconcilliationFleet && ( */} {/* MFA Changes */}
        { isEnergyBillReconcilliationFleet && (
          // ispdfDownload &&
          <div className="col-md-3">
            <Link to="/dashboard_bus/energybillreconcilliation_bus">
              <div className="dashboard_card">
                <img
                  src="../../../assets/img_Bus/Energy_Bill_Reconcilliation_icon.png"
                  alt=""
                />
                <span>Energy Bill Reconcilliation</span>
              </div>
            </Link>
          </div>
        )}

      </div>
      {/* {loggedInUser.flagForHideShow === "ERC" && isChatBot && (
        <div className="small_chatbot">
          <ChatBot
            settings={{
              header: { title: "Fleet Ascent Saarathi" },
              chatButton: {
                // icon: "../../../assets/img_Bus/Pdf_Page/monthlyReport.png",
                icon: "../../../assets/img_Bus/bot_icon.png",
                mode: "",
              },
              tooltip: { text: "Fleet Ascent Saarathi" },
            }}
            options={{
              chatHistory: { storageKey: "example_smart_conversation" },
            }}
            flow={flow}
          // style={{ width: "700px", height: "400px" }}
          />
        </div>
      )} */}
    </LayoutMain_Bus>
  );
}
